import {Component, computed, inject, Signal} from '@angular/core'
import {toObservable, toSignal} from '@angular/core/rxjs-interop'
import {MatIconButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer'
import {map, of, switchMap} from 'rxjs'
import {OrientationService} from '../../services/orientation.service'
import {PdfProxyService} from '../../services/pdf-proxy.service'

@Component({
  selector: 'spb-pdf-viewer',
  imports: [
    MatIcon,
    MatIconButton,
    NgxExtendedPdfViewerModule
  ],
  templateUrl: './pdf-viewer.component.html',
  styleUrl: './pdf-viewer.component.scss'
})
export class PdfViewerComponent {
  public orientationService = inject(OrientationService)
  public proxyService = inject(PdfProxyService)
  public isPdfLoaded: Signal<boolean>
  protected src: Signal<string>
  protected base64Src: Signal<string>

  constructor() {
    const pdfResource$ = toObservable(this.orientationService.pdfUrl$).pipe(
      switchMap(url => {
        if (!url) {
          return of(null)
        }

        // Check if internal link
        if (url.includes('./assets/links/')) {
          return of({src: url, base64Src: ''})
        }

        // External link via proxy
        return this.proxyService.getProxiedPdfUrl(url).pipe(
          map(response => ({src: '', base64Src: response.body}))
        )
      })
    )

    // Convert stream to a signal (initially undefined/loading)
    const state = toSignal(pdfResource$)

    // Initialize the members from the local state
    this.src = computed(() => state()?.src || '')
    this.base64Src = computed(() => state()?.base64Src || '')

    this.isPdfLoaded = computed(() => {
      const s = state()
      return !!(s?.src || s?.base64Src)
    })
  }
}